import React from 'react';
import { StyledNavIcon, StyledNavButton, StyledNavIconWrapper } from './styledNavItem';

interface INavItemProps {
  icon?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
  name: string;
  extraLabel?: string;
  className?: string;
  $active?: boolean;
  /**
   * component props will be passed through
   */
  [key: string]: unknown;
}

const NavItem = ({ icon, name, extraLabel, className, $active, ...otherProps }: INavItemProps) => (
  <StyledNavButton
    className={className}
    buttonType="tertiary"
    $active={$active}
    aria-current={$active ? 'page' : undefined}
    {...otherProps}
  >
    {icon && (
      <StyledNavIconWrapper>
        <StyledNavIcon as={icon} />
      </StyledNavIconWrapper>
    )}
    {name}
    {extraLabel && <span className="nav-item-extra-label">{extraLabel}</span>}
  </StyledNavButton>
);

export default NavItem;
